const CRITICAL_KEYWORDS = [
  "suicid",
  "muerte",
  "morir",
  "matarme",
  "anhedonia",
  "placer",
  "desesper",
  "vida",
  "ideaci",
  "lastim",
  "dano",
];

const BECK_TEST_PRIORITY = [
  "depression_beck_test",
  "anxiety_beck_test",
  "depression_yesavage_test",
];

export const normalizeTestName = (name) =>
  String(name || "")
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .toLowerCase()
    .replace(/\s+/g, "_");

const isSemanticallyCritical = (text) => {
  const normalized = String(text || "").toLowerCase();
  return CRITICAL_KEYWORDS.some((keyword) => normalized.includes(keyword));
};

const mapResultItem = (item) => {
  const value = Number(item.valueselected);
  const text = item.textselected || "Sin respuesta";
  const numericValue = Number.isNaN(value) ? 0 : value;

  return {
    index: item.indexselected,
    text,
    value: numericValue,
    isHighScore: numericValue >= 2,
    isSemanticallyCritical: isSemanticallyCritical(text),
    isCritical: numericValue >= 2 || isSemanticallyCritical(text),
  };
};

const getTestPriority = (testName) => {
  const normalized = normalizeTestName(testName);
  const index = BECK_TEST_PRIORITY.findIndex(
    (key) => normalized === key || normalized.includes(key.replace(/_/g, ""))
  );
  return index === -1 ? BECK_TEST_PRIORITY.length : index;
};

export const buildCriticalItemsBreakdown = (tests = []) => {
  const testsWithItems = (tests || []).filter(
    (test) =>
      Array.isArray(test.resultsList) && test.resultsList.length > 0
  );

  const latestByTest = new Map();

  for (const test of testsWithItems) {
    const testName = test.testName || "Sin nombre";
    const current = latestByTest.get(testName);

    if (!current || new Date(test.testDay) > new Date(current.testDay)) {
      latestByTest.set(testName, test);
    }
  }

  const breakdowns = [...latestByTest.entries()]
    .map(([testName, test]) => {
      const items = test.resultsList
        .map(mapResultItem)
        .sort((a, b) => b.value - a.value);

      const maxValue = Math.max(...items.map((item) => item.value), 1);
      const criticalCount = items.filter((item) => item.isCritical).length;

      return {
        testName,
        testDay: test.testDay,
        items,
        maxValue,
        criticalCount,
        priority: getTestPriority(testName),
      };
    })
    .sort((a, b) => a.priority - b.priority || a.testName.localeCompare(b.testName));

  return {
    breakdowns,
    hasData: breakdowns.length > 0,
    defaultTestName: breakdowns[0]?.testName ?? null,
  };
};

export const getBreakdownByTestName = (breakdowns, testName) =>
  breakdowns.find((entry) => entry.testName === testName) ?? null;
